

































































import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
// components
import ImageElementSettings from "./ImageElementSettings.vue";
import HeroHeadlineElementSettings from "./HeroHeadlineElementSettings.vue";
import MarkdownElementSettings from "./MarkdownElementSettings.vue";
import TextElementSettings from "./TextElementSettings.vue";
import SequentialListElementSettings from "./SequentialListElementSettings.vue";
import FlipCardListElementSettings from "./FlipCardListElementSettings.vue";
import PdfElementSettings from "./PdfElementSettings.vue";
import AudioElementSettings from "./AudioElementSettings.vue";
import TtsAudioElementSettings from "./TtsAudioElementSettings.vue";
import TtsReaderElementSettings from "./TtsReaderElementSettings.vue";
import AudioPodcastElementSettings from "./AudioPodcastElementSettings.vue";
import VideoElementSettings from "./VideoElementSettings.vue";
import MultipleChoiceElementSettings from "./MultipleChoiceElementSettings.vue";
import SingleChoiceElementSettings from "./SingleChoiceElementSettings.vue";
import SignatureElementSettings from "./SignatureElementSettings.vue";
import SliderElementSettings from "./SliderElementSettings.vue";
import RatingElementSettings from "./RatingElementSettings.vue";
import CommentElementSettings from "./CommentElementSettings.vue";
import ScormElementSettings from "./ScormElementSettings.vue";
// interfaces

const globals = namespace("globals");

@Component({
  components: {
    TextElementSettings,
    MarkdownElementSettings,
    SequentialListElementSettings,
    FlipCardListElementSettings,
    PdfElementSettings,
    ImageElementSettings,
    HeroHeadlineElementSettings,
    AudioElementSettings,
    TtsAudioElementSettings,
    TtsReaderElementSettings,
    AudioPodcastElementSettings,
    SingleChoiceElementSettings,
    MultipleChoiceElementSettings,
    VideoElementSettings,
    SignatureElementSettings,
    SliderElementSettings,
    RatingElementSettings,
    CommentElementSettings,
    ScormElementSettings
  },
})
export default class ElementSettings extends Vue {
  // @globals.Getter selectedExercise!: ExerciseVM;
  // @globals.Getter selectedModulePage!: CcPageVm | null;
  @globals.Getter selectedElement!: CourseElementVm | null;
  // @globals.Action setElement!: (element: CourseElementVm | null) => Promise<void>;

  // courseElementTypeItems = courseElementTypeItems;

  // @Watch("selectedExercise")
  // async onSelectedExerciseChange() {
  // }
}
